module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.c20b9740.woff";